<template>
    <div class="container">
        <div class="common-header-wrap">
            <mt-header :title="getTitle" class="common-header">
                <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
				<div class="common-btn btn" slot="right" @click="onDelete" v-if="!isAddMode">删除</div>
            </mt-header>
        </div>
		<div class='main-content'>
			<div v-if="isAddMode">
				<flex-line class="menu-item" :show-border="true"><span class="field-line field-name">商城账号</span><div class="field-line-right" slot="right"><input class="field-input" v-model="seller.member_name" /></div></flex-line>
				<flex-line class="menu-item" :show-border="true"><span class="field-line field-name">卖家账号</span><div class="field-line-right" slot="right"><input class="field-input" v-model="seller.seller_name" /></div></flex-line>
				<flex-line class="menu-item" :show-border="true"><span class="field-line field-name">密码</span><div class="field-line-right" slot="right"><input class="field-input" type="password" v-model="seller.password" /></div></flex-line>
			</div>
			<div v-else>
				<flex-line class="menu-item" :show-border="true"><span class="field-line field-name">卖家账号</span><div class="field-line-right" slot="right"><input class="field-input" v-model="seller.seller_name" /></div></flex-line>
			</div>
			<div class="select" @click="popupVisible = true"><flex-line class="menu-item" :is-link="true" :show-border="true"><span class="line-name">账号组</span><span slot="right">{{seller.sellergroup_name?seller.sellergroup_name: '请选择'}}</span></flex-line></div>
			<div class="pt-10 pb-10"><div class="common-btn ds-button-large" @click="submit">提交</div></div>
		</div>
        <mt-popup v-model="popupVisible" position="bottom" class="mint-popup">
            <mt-picker :slots="sellerGroupList" @change="onSellerGroupChange" ref="picker" :visible-item-count="5" value-key="sellergroup_name"></mt-picker>
            <div class="pt-10 pb-10"><div class="common-btn ds-button-large" @click="handleConfirm">确认</div></div>
        </mt-popup>

    </div>
</template>

<script>
import { Toast, Indicator, MessageBox } from 'mint-ui'
import flexLine from '../../flexLine'
import { getSellerAccountInfo, getSellerAccountGroupList, delSellerAccount, editSellerAccount, addSellerAccount } from '../../../api/sellerAccount'
export default {
	components: {
		flexLine
	},
  name: 'AccountForm',
  data () {
    return {
      popupVisible: false,
      sellergroup_list: [], // 账号组
      seller: {
        'seller_id': 0,
        'member_name': '', // 商城用户名
        'seller_name': '', // 卖家用户名
        'password': '',
        'sellergroup_id': 0,
        'sellergroup_name': ''
      }
    }
  },
  created: function () {
    // 获取店铺的账户组
    getSellerAccountGroupList().then(res => {
      this.sellergroup_list = res.result.sellergroup_list
    }).catch(function (error) {
      Toast(error.message)
    })

    if (!this.isAddMode) {
      this.seller.seller_id = this.$route.query.seller_id
      getSellerAccountInfo(this.seller.seller_id).then(res => {
        this.seller = res.result.seller_info
      }).catch(function (error) {
        Toast(error.message)
      })
    }
  },
  computed: {
    isAddMode () {
      let mode = this.$route.query.action
      if (mode === 'add') {
        return true
      } else {
        return false
      }
    },
    getTitle () {
      if (this.isAddMode) {
        return '新增账户'
      } else {
        return '修改账户'
      }
    },
    sellerGroupList () {
      let sellerGroupList = [
        {
          flex: 1,
          values: this.sellergroup_list,
          className: 'slot1',
          textAlign: 'center'
        }
      ]
      return sellerGroupList
    }

  },
  methods: {
    // 确认事件
    handleConfirm () {
      this.seller.sellergroup_id = this.$refs.picker.getValues()[0]['sellergroup_id']
      this.seller.sellergroup_name = this.$refs.picker.getValues()[0]['sellergroup_name']
      this.popupVisible = false
    },
    // 选择事件
    onSellerGroupChange (picker, values) {
      // this.seller.sellergroup_id = values[0]
    },
    onDelete () {
      MessageBox.confirm('确定要取消该账号吗？').then(action => {
        delSellerAccount(this.seller.seller_id).then(
          (response) => {
            this.$router.push({ name: 'SellerAccountList' })
          }, (error) => {
            Toast(error.message)
          })
      })
    },
    submit () {
      if (this.isAddMode) {
        Indicator.open()
        addSellerAccount(this.seller).then(
          (response) => {
            Indicator.close()
            Toast(response.message)
            this.$router.push({ name: 'SellerAccountList' })
          }, (error) => {
            Indicator.close()
            Toast(error.message)
          })
      } else {
        Indicator.open()
        editSellerAccount(this.seller).then(
          (response) => {
            Indicator.close()
            Toast(response.message)
            // this.$router.push({ name: 'SellerAccountList' })
          }, (error) => {
            Indicator.close()
            Toast(error.message)
          })
      }
    }
  }
}
</script>

<style scoped lang='scss'>
.common-header{
	.btn{background: #000;color: #fff;box-shadow: 0px 2px 4px #d2d2d2;}
}
.main-content{padding:0 $pageSpace;background: #fff}
</style>
